import { ELifeScienceStatusCode } from '@aca-new/app/pages/life-science/shared/enums/life-science-status-code.enum';
import { ELifeScienceStatus } from '@aca-new/app/pages/life-science/shared/enums/life-science-status.enum';
import { EServiceType } from '@aca-new/app/shared/models/enums/service-type.enum';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dotLabelClass',
  pure: true,
  standalone: true,
})
export class DotLabelClassPipe implements PipeTransform {
  public transform(className: Readonly<string>, status?: Readonly<string>): string {
    const [prefix, label] = className.split('--');
    const pendingStatus: string[] = [
      ELifeScienceStatus.ON_HOLD_BY_QIMA,
      ELifeScienceStatus.SUSPEND_BY_CLIENT,
      ELifeScienceStatus.PENDING,
      ELifeScienceStatus.PENDING_PO,
      ELifeScienceStatus.PENDING_FEEDBACK,
      ELifeScienceStatus.PENDING_TEST_ITEM,
      ELifeScienceStatus.PENDING_PAYMENT,
    ];
    const acceptedStatus: string[] = [
      ELifeScienceStatus.ON_GOING,
      ELifeScienceStatus.RESULTS_READY,
      ELifeScienceStatus.COMPLETED,
      ELifeScienceStatus.IN_PROGRESS,
      ELifeScienceStatus.CREATED,
      ELifeScienceStatus.STUDY_REPORT,
    ];

    if (label === ELifeScienceStatus.ON_HOLD && status === EServiceType.LT) {
      return `${prefix}--Expired`;
    }

    if (status === ELifeScienceStatusCode.REPORT_ARCHIVED) {
      return `${prefix}--${status}`;
    }

    if (pendingStatus.includes(label)) {
      return `${prefix}--Pending`;
    }

    if (acceptedStatus.includes(label)) {
      return `${prefix}--Accepted`;
    }

    return `${prefix}--${label}`;
  }
}
